export default __webpack_public_path__ + "static/media/1956.b9b0f142.png";